import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { headerActions } from '../../../store/admin/header';
import { sidebarActions } from '../../../store/admin/sidebar';

//import DropdownNotification from './dropdown/notification';
import DropdownLanguage from './dropdown/language';
import DropdownProfile from './dropdown/profile';
import SearchForm from './search/form';
import DropdownMegaMenu from './dropdown/mega';

import kara from '../../../assets/admin/img/logo_karaedu_175x44_@2.png';

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.toggleMegaMenu = this.toggleMegaMenu.bind(this);
        this.state = { collapseMegaMenu: false };
    }

    toggleMegaMenu() {
        this.setState({ collapseMegaMenu: !this.state.collapseMegaMenu });
    }

    render() {

        const logo = `${kara}#svgView(preserveAspectRatio(none))`;

        return (
            <div id="header" className="header navbar-default">
                <div className="navbar-header">
                    {this.props.header.pageTwoSidebar && (
                        <button type="button" className="navbar-toggle pull-right" onClick={this.props.toggleMobileSidebar}>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    )}
                    {this.props.header.pageTwoSidebar && (
                        <button type="button" className="navbar-toggle pull-left" onClick={this.props.toggleMobileRightSidebar}>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    )}

                    <Link to="/" className="navbar-brand"><img src={logo} style={{ width: "284px" }} alt="ī��" /></Link>

                    {!this.props.header.pageTwoSidebar && (
                        <button type="button" className="navbar-toggle" onClick={this.props.toggleMobileSidebar}>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    )}
                    {this.props.header.pageHeaderMegaMenu && (
                        <button type="button" className="navbar-toggle p-0 m-r-0" onClick={this.props.toggleMegaMenu}>
                            <span className="fa-stack fa-lg text-inverse m-t-2">
                                <i className="far fa-square fa-stack-2x"></i>
                                <i className="fa fa-cog fa-stack-1x"></i>
                            </span>
                        </button>
                    )}
                </div>

                {this.props.header.pageHeaderMegaMenu && (
                    <DropdownMegaMenu collapse={this.state.collapseMegaMenu} />
                )}

                <ul className="navbar-nav navbar-right">
                    <SearchForm />

                    {/* < DropdownNotification /> */}

                    {this.props.header.pageHeaderLanguageBar && (
                        <DropdownLanguage />
                    )}

                    <DropdownProfile />

                    {this.props.header.pageTwoSidebar && (
                        <li className="divider d-none d-md-block"></li>
                    )}

                    {this.props.header.pageTwoSidebar && (
                        <li className="d-none d-md-block">
                            <Link to="/" onClick={this.props.toggleRightSidebar} className="f-s-14">
                                <i className="fa fa-th"></i>
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
        )
    }
}

export default connect(
    state => state,
    dispatch => bindActionCreators({ ...sidebarActions, ...headerActions }, dispatch)
)(Header);






// WEBPACK FOOTER //
// ./src/components/admin/header/header.js